/* eslint-disable eqeqeq */
import { useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import useMediaQuery from "@mui/material/useMediaQuery";
import moment from "moment";
import CloseIcon from "@mui/icons-material/Close";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
// common_groupstructure_GETROW
import Grid from "@mui/material/Grid";
import WmsHead from "./processComponent/WmsHead";
import WmsContent from "./processComponent/WmsContent";
import "./WMSSalesReport.css";
import { CmpButton } from "../../Component/Common/ToolBox/ToolBox";
// fExecuteAPI
import GCWebReport from "../../Component/Common/ReuseableComponent/GCWebReport";

import {
  ReportTitle,
  ReportRemoveSequenceChar,
  ReportUrl,
} from "../../Utility/Utilitys";

import {
  HeadObjectInit,
  sWebWMSSalesReportData,
  sWebBetweenReportArr,
  sWebTransTypeReportArr,
  fWmsStockRepotArr,
  fWmsStockRepotBrandArr,
  GetWmsStockRepotBrand,
  GetLocation,
  GetWMSMISAttributes,
  GetItemsAnalysis,
  GetWmsStockRepotVendor,
  GetItemFullSearchArr,
  GetSearchItem,
  fValidationHead_Client,
  fValidationDetail_Client,
  sWMSSalesReportCheckboxInit,
  SummaryReporteData,
  DetailReporteData,
  AnalysisReporteData,
  ComparisionReporteData,
} from "./WMSSalesReportAction";

import * as React from "react";
import GCTitleSticky from "../../Component/Common/ReuseableComponent/GCTitleSticky";

export default function WMSSalesReport() {
  const vMediaQuery = useMediaQuery("(max-width:450px)");
  const vRdxuserInfo = useSelector((state) => state.login.value);

  //Head
  const [HeadObject, setHeadObject] = useState(HeadObjectInit);

  const [sDetailSelectReportData, setDetailSelectReportData] =
    useState(SummaryReporteData);

  const sBufferObjInit = {
    sDetailReportRadioBtnName: "SUMMARY", //DETAIL ,ANALYSIS ,COMPARISON
    DetailSelectedReport: SummaryReporteData[0].Uid,
    DetailSelectedReportName: SummaryReporteData[0].Value,
    sComprSales_FromDt: new Date(),
    sComprSales_ToDt: new Date(),
    sCompr_FromDt: new Date(),
    sCompr_ToDt: new Date(),
    sDetailSalesAbvCost: "",
    sDetailSalesBelowCost: "",
    sDetailSalesAboveBtCostFrom: "",
    sDetailSalesAboveBtCostTo: "",
    sSummaryLocCustCheckBox: "N",
  };

  const [sBufferObj, setBufferObj] = useState(sBufferObjInit);

  const [sLocationData, setLocationData] = useState([
    // { Uid: "Distribution", Value: "Distribution" },
  ]);

  const [sMainGroupData, setMainGroupData] = useState([]);

  const [sSubGroupData, setSubGroupData] = useState([]);

  const [sGroupData, setGroupData] = useState([]);

  const [sBrandData, setBrandData] = useState([]);
  const [sBrandGroupData, setBrandGroupData] = useState([]);

  const [sCountryData, setCountryData] = useState([]);

  const [sSeasonData, setSeasonData] = useState([]);
  const [sSalesManData, setSalesManData] = useState([]);

  const [sDocTypeData, setDocTypeData] = useState([]);

  const [sVendorData, setVendorData] = useState([]);
  const [sCustomerData, setCustomerData] = useState([]);

  const [sProperty1Data, setProperty1Data] = useState([]);
  const [sProperty2Data, setProperty2Data] = useState([]);
  const [sProperty3Data, setProperty3Data] = useState([]);
  const [sProperty4Data, setProperty4Data] = useState([]);
  const [sAnalysis1Data, setAnalysis1Data] = useState([]);
  const [sAnalysis2Data, setAnalysis2Data] = useState([]);
  const [sAnalysis3Data, setAnalysis3Data] = useState([]);
  const [sAnalysis4Data, setAnalysis4Data] = useState([]);
  const [sAnalysis5Data, setAnalysis5Data] = useState([]);
  const [sAnalysis6Data, setAnalysis6Data] = useState([]);
  const [sAnalysis7Data, setAnalysis7Data] = useState([]);
  //checkbox Start
  const [sWMSSalesReportCheckBoxModal, setWMSSalesReportCheckBoxModal] =
    useState(false);

  const fOpenWMSSalesReportCheckBoxModal = () => {
    setWMSSalesReportCheckBoxModal(true);
  };

  const fCloseWMSSalesReportCheckBoxModal = (e) => {
    setWMSSalesReportCheckBoxModal(false);
  };

  const [sIsChecked, setIsChecked] = useState(false);
  const [WMSSalesReportCheckbox, setWMSSalesReportCheckbox] = useState({
    sProperty1Data: false,
    sProperty2Data: false,
    sProperty3Data: false,
    sProperty4Data: false,
    sAnalysis1Data: false,
    sAnalysis2Data: false,
    sAnalysis3Data: false,
    sAnalysis4Data: false,
    sAnalysis5Data: false,
    sAnalysis6Data: false,
    sAnalysis7Data: false,
    sTransTypeData: false,
  });
  const fSetCheckBox = (e) => {
    const nameValue = e.target.name;
    const iSCheck = e.target.checked;
    setWMSSalesReportCheckbox((values) => ({
      ...values,
      [nameValue]: iSCheck,
    }));
  };

  const fIsAllChecked = (e) => {
    const iSCheck = e.target.checked;
    setIsChecked(iSCheck);
    setWMSSalesReportCheckbox({
      sProperty1Data: iSCheck,
      sProperty2Data: iSCheck,
      sProperty3Data: iSCheck,
      sProperty4Data: iSCheck,
      sAnalysis1Data: iSCheck,
      sAnalysis2Data: iSCheck,
      sAnalysis3Data: iSCheck,
      sAnalysis4Data: iSCheck,
      sAnalysis5Data: iSCheck,
      sAnalysis6Data: iSCheck,
      sAnalysis7Data: iSCheck,
      sTransTypeData: iSCheck,
    });
  };

  useEffect(() => {
    const vIsAllTrue = Object.values(WMSSalesReportCheckbox).every(
      (value) => value === true
    );
    setIsChecked(vIsAllTrue);
  }, [WMSSalesReportCheckbox]);
  //checkbox End
  const fResetOnchange = () => {
    setBufferObj((obj) => ({
      ...obj,
      sComprSales_FromDt: new Date(),
      sComprSales_ToDt: new Date(),
      sCompr_FromDt: new Date(),
      sCompr_ToDt: new Date(),
      sDetailSalesAbvCost: "",
      sDetailSalesBelowCost: "",
      sDetailSalesAboveBtCostFrom: "",
      sDetailSalesAboveBtCostTo: "",
      sSummaryLocCustCheckBox: "N",
    }));
  };
  const DetailReportRadioBtn = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      sDetailReportRadioBtnName: e.target.value,
    }));
    fResetOnchange();
    if (e.target.value == "SUMMARY") {
      // SummaryReporteData
      setDetailSelectReportData(SummaryReporteData);
      setBufferObj((obj) => ({
        ...obj,
        DetailSelectedReport: SummaryReporteData[0].Uid,
        DetailSelectedReportName: SummaryReporteData[0].Value,
      }));
    } else if (e.target.value == "DETAIL") {
      setDetailSelectReportData(DetailReporteData);
      setBufferObj((obj) => ({
        ...obj,
        DetailSelectedReport: DetailReporteData[0].Uid,
        DetailSelectedReportName: DetailReporteData[0].Value,
      }));
    } else if (e.target.value == "ANALYSIS") {
      setDetailSelectReportData(AnalysisReporteData);
      setBufferObj((obj) => ({
        ...obj,
        DetailSelectedReport: AnalysisReporteData[0].Uid,
        DetailSelectedReportName: AnalysisReporteData[0].Value,
      }));
    } else if (e.target.value == "COMPARISON") {
      setDetailSelectReportData(ComparisionReporteData);
      setBufferObj((obj) => ({
        ...obj,
        DetailSelectedReport: ComparisionReporteData[0].Uid,
        DetailSelectedReportName: ComparisionReporteData[0].Value,
      }));
    }
  };
  const fDetailSelectedReport = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      DetailSelectedReport: e.target.value,
      DetailSelectedReportName: e.target.name,
    }));
    fResetOnchange();
  };
  const fCompr_ToDt = (e) => {
    if (
      e?.$d == "Invalid Date" ||
      e?.$d == null ||
      e?.$d === undefined ||
      e?.$d === ""
    ) {
      setBufferObj((obj) => ({
        ...obj,
        sCompr_ToDt: "",
      }));
    } else {
      setBufferObj((obj) => ({
        ...obj,
        sCompr_ToDt: e?.$d,
      }));
    }
  };
  const fCompr_FromDt = (e) => {
    if (
      e?.$d == "Invalid Date" ||
      e?.$d == null ||
      e?.$d === undefined ||
      e?.$d === ""
    ) {
      setBufferObj((obj) => ({
        ...obj,
        sCompr_FromDt: "",
      }));
    } else {
      setBufferObj((obj) => ({
        ...obj,
        sCompr_FromDt: e?.$d,
      }));
    }
  };
  const fComprSales_ToDt = (e) => {
    if (
      e?.$d == "Invalid Date" ||
      e?.$d == null ||
      e?.$d === undefined ||
      e?.$d === ""
    ) {
      setBufferObj((obj) => ({
        ...obj,
        sComprSales_ToDt: "",
      }));
    } else {
      setBufferObj((obj) => ({
        ...obj,
        sComprSales_ToDt: e?.$d,
      }));
    }
  };
  const fComprSales_FromDt = (e) => {
    if (
      e?.$d == "Invalid Date" ||
      e?.$d == null ||
      e?.$d === undefined ||
      e?.$d === ""
    ) {
      setBufferObj((obj) => ({
        ...obj,
        sComprSales_FromDt: "",
      }));
    } else {
      setBufferObj((obj) => ({
        ...obj,
        sComprSales_FromDt: e?.$d,
      }));
    }
  };

  const fDetailSalesAbvCost = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      sDetailSalesAbvCost: e.target.value,
    }));
  };
  const fDetailSalesBelowCost = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      sDetailSalesBelowCost: e.target.value,
    }));
  };

  const fDetailSalesAboveBtCostTo = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      sDetailSalesAboveBtCostTo: e.target.value,
    }));
  };
  const fDetailSalesAboveBtCostFrom = (e) => {
    setBufferObj((obj) => ({
      ...obj,
      sDetailSalesAboveBtCostFrom: e.target.value,
    }));
  };
  const fSummaryLocCustCheckBox = (e) => {
    if (e.target.checked) {
      setBufferObj((obj) => ({
        ...obj,
        sSummaryLocCustCheckBox: "Y",
      }));
    } else {
      setBufferObj((obj) => ({
        ...obj,
        sSummaryLocCustCheckBox: "N",
      }));
    }
  };
  //Detail

  //Head
  const fDate = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sDate: e.target.value,
      sFromDate: new Date(),
      sToDate: new Date(),
    }));
  };
  const fFromDate = (e) => {
    if (
      e?.$d == "Invalid Date" ||
      e?.$d == null ||
      e?.$d === undefined ||
      e?.$d === ""
    ) {
      setHeadObject((obj) => ({
        ...obj,
        sFromDate: "",
      }));
    } else {
      setHeadObject((obj) => ({
        ...obj,
        sFromDate: e?.$d,
      }));
    }
  };
  const fToDate = (e) => {
    if (
      e?.$d == "Invalid Date" ||
      e?.$d == null ||
      e?.$d === undefined ||
      e?.$d === ""
    ) {
      setHeadObject((obj) => ({
        ...obj,
        sToDate: "",
      }));
    } else {
      setHeadObject((obj) => ({
        ...obj,
        sToDate: e?.$d,
      }));
    }
  };
  const fCountry = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sCountry: e.target.value,
      sCountryrArr: [],
      sCountryrPrnt: "",
      sCountryrName: "",
    }));
  };
  const fCountry_MultiSelect = (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sCountryArr: value,
      sCountryPrnt: value?.length <= 0 ? "" : currentPrnt,
      sCountryName: value?.length <= 0 ? "" : currentName,
    }));
  };

  const fSeason = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sSeason: e.target.value,
      sSeasonArr: [],
      sSeasonPrnt: "",
      sSeasonName: "",
    }));
  };
  const fSeason_MultiSelect = (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sSeasonArr: value,
      sSeasonPrnt: value?.length <= 0 ? "" : currentPrnt,
      sSeasonName: value?.length <= 0 ? "" : currentName,
    }));
  };

  const fSalesMan = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sSalesMan: e.target.value,
      sSalesManArr: [],
      sSalesManPrnt: "",
      sSalesManName: "",
    }));
  };
  const fSalesMan_MultiSelect = (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sSalesManArr: value,
      sSalesManPrnt: value?.length <= 0 ? "" : currentPrnt,
      sSalesManName: value?.length <= 0 ? "" : currentName,
    }));
  };

  const fDocType = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sDocType: e.target.value,
      sDocTypeArr: [],
      sDocTypePrnt: "",
      sDocTypeName: "",
    }));
  };
  const fDocType_MultiSelect = (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sDocTypeArr: value,
      sDocTypePrnt: value?.length <= 0 ? "" : currentPrnt,
      sDocTypeName: value?.length <= 0 ? "" : currentName,
    }));
  };

  const fLocation = async (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sLocation: e.target.value,
      sLocationArr: [],
      sLocationPrnt: "",
      sLocationName: "",
      sCountry: "All",
      sCountryCode: "",
      sCountryPrnt: "",
      sCountryName: "",
    }));
  };

  const fLocation_MultiSelect = async (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sLocationArr: value,
      sLocationPrnt: value?.length <= 0 ? "" : currentPrnt,
      sLocationName: value?.length <= 0 ? "" : currentName,
    }));
    if (value?.length <= 0) {
      fLocation_Focus();
    }
  };
  const fLocation_Focus = (value) => {
    setHeadObject((obj) => ({
      ...obj,
      sCountry: "All",
      sCountryArr: [],
      sCountryPrnt: "",
      sCountryName: "",
    }));
  };

  const fMainGroup = async (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sMainGroup: e.target.value,
      sMainGroupArr: [],
      sMainGroupPrnt: "",
      sMainGroupName: "",
      sSubGroup: "All",
      sSubGroupArr: [],
      sSubGroupPrnt: "",
      sSubGroupName: "",
      sGroup: "All",
      sGroupArr: [],
      sGroupPrnt: "",
      sGroupName: "",
    }));
    setSubGroupData([]);
    setGroupData([]);

    if (e.target.value.toUpperCase() == "ALL") {
      setMainGroupData([]);
    } else if (e.target.value.toUpperCase() == "IS") {
      let xGroupStructureObj = {
        Prnt: "",
        Lvl: "1",
      };
      await fWmsStockRepotArr(xGroupStructureObj, setMainGroupData);
    }
  };

  const fMainGroup_MultiSelect = async (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sMainGroupArr: value,
      sMainGroupPrnt: value?.length <= 0 ? "" : currentPrnt,
      sMainGroupName: value?.length <= 0 ? "" : currentName,
    }));
    fMainGroup_Focus();
  };
  const fMainGroup_Focus = (value) => {
    setHeadObject((obj) => ({
      ...obj,
      sSubGroup: "All",
      sSubGroupArr: [],
      sSubGroupPrnt: "",
      sSubGroupName: "",
      sGroup: "All",
      sGroupArr: [],
      sGroupPrnt: "",
      sGroupName: "",
    }));
    setSubGroupData([]);
    setGroupData([]);
  };

  const fSubGroup = async (e) => {
    setHeadObject((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
      sSubGroupArr: [],
      sSubGroupPrnt: "",
      sSubGroupName: "",
      sGroup: "All",
      sGroupArr: [],
      sGroupPrnt: "",
      sGroupName: "",
    }));

    setGroupData([]);
    if (e.target.value.toUpperCase() == "ALL") {
      setSubGroupData([]);
    } else if (e.target.value.toUpperCase() == "IS") {
      let xGroupStructureObj2 = {
        Prnt: HeadObject.sMainGroupPrnt,
        Lvl: "2",
      };
      await fWmsStockRepotArr(xGroupStructureObj2, setSubGroupData);
    }
  };

  const fSubGroup_MultiSelect = (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sSubGroupArr: value,
      sSubGroupPrnt: value?.length <= 0 ? "" : currentPrnt,
      sSubGroupName: value?.length <= 0 ? "" : currentName,
    }));
    fSubGroup_Focus();
  };

  const fSubGroup_Focus = (value) => {
    setHeadObject((obj) => ({
      ...obj,
      sGroup: "All",
      sGroupArr: [],
      sGroupPrnt: "",
      sGroupName: "",
    }));
    setGroupData([]);
  };

  const fGroup = async (e) => {
    setHeadObject((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
      sGroupArr: [],
      sGroupPrnt: "",
      sGroupName: "",
    }));

    if (e.target.value.toUpperCase() == "ALL") {
      setGroupData([]);
    } else if (e.target.value.toUpperCase() == "IS") {
      let xGroupStructureObj2 = {
        Prnt: HeadObject.sSubGroupPrnt,
        Lvl: "3",
      };

      await fWmsStockRepotArr(xGroupStructureObj2, setGroupData);
    }
  };

  const fGroup_MultiSelect = (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sGroupArr: value,
      sGroupPrnt: value?.length <= 0 ? "" : currentPrnt,
      sGroupName: value?.length <= 0 ? "" : currentName,
    }));
    fGroup_Focus();
  };
  const fGroup_Focus = (value) => {};

  const fBrand = async (e) => {
    setHeadObject((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
      sBrandArr: [],
      sBrandPrnt: "",
      sBrandName: "",
      sBrandGroupArr: [],
      sBrandGroupPrnt: "",
      sBrandGroupCode: "",
      sBrandGroupName: "",
    }));
    setBrandGroupData([]);
    if (e.target.value.toUpperCase() == "ALL") {
      setBrandData([]);
    } else if (e.target.value.toUpperCase() == "IS") {
      await GetWmsStockRepotBrand(setBrandData);
    }
  };
  const fBrand_MultiSelect = async (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sBrandArr: value,
      sBrandPrnt: value?.length <= 0 ? "" : currentPrnt,
      sBrandName: value?.length <= 0 ? "" : currentName,
    }));
    let xGroupStructureObj = {
      grp: value?.length <= 0 ? "" : currentPrnt,
    };
    await fWmsStockRepotBrandArr(xGroupStructureObj, setBrandGroupData);
    fBrand_Focus();
  };

  const fBrand_Focus = (value) => {
    setHeadObject((obj) => ({
      ...obj,
      sBrandGroupArr: [],
      sBrandGroupPrnt: "",
      sBrandGroupCode: "",
      sBrandGroupName: "",
    }));
  };

  const fBrandGroup_MultiSelect = (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sBrandGroupArr: value,
      sBrandGroupPrnt: value?.length <= 0 ? "" : currentPrnt,
      sBrandGroupName: value?.length <= 0 ? "" : currentName,
    }));
  };

  //common_VendorListReport_GETROW
  const fVendor = async (e) => {
    setHeadObject((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
      sVendorArr: [],
      sVendorPrnt: "",
      sVendorName: "",
    }));
    if (e.target.value.toUpperCase() == "ALL") {
      setVendorData([]);
    } else if (e.target.value.toUpperCase() == "IS") {
      await GetWmsStockRepotVendor(setVendorData);
    }
  };
  const fVendor_MultiSelect = async (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sVendorArr: value,
      sVendorPrnt: value?.length <= 0 ? "" : currentPrnt,
      sVendorName: value?.length <= 0 ? "" : currentName,
    }));
  };

  //common_CustomerListReport_GETROW
  const fCustomer = async (e) => {
    setHeadObject((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
      sCustomerArr: [],
      sCustomerPrnt: "",
      sCustomerName: "",
    }));
  };
  const fCustomer_MultiSelect = async (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sCustomerArr: value,
      sCustomerPrnt: value?.length <= 0 ? "" : currentPrnt,
      sCustomerName: value?.length <= 0 ? "" : currentName,
    }));
  };

  const fProperty1 = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sProperty1: e.target.value,
      sProperty1Arr: [],
      sProperty1Prnt: "",
      sProperty1Name: "",
    }));
  };
  const fProperty1_MultiSelect = (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sProperty1Arr: value,
      sProperty1Prnt: value?.length <= 0 ? "" : currentPrnt,
      sProperty1Name: value?.length <= 0 ? "" : currentName,
    }));
  };

  const fProperty2 = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sProperty2: e.target.value,
      sProperty2Arr: [],
      sProperty2Prnt: "",
      sProperty2Name: "",
    }));
  };
  const fProperty2_MultiSelect = (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sProperty2Arr: value,
      sProperty2Prnt: value?.length <= 0 ? "" : currentPrnt,
      sProperty2Name: value?.length <= 0 ? "" : currentName,
    }));
  };

  const fProperty3 = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sProperty3: e.target.value,
      sProperty3Arr: [],
      sProperty3Prnt: "",
      sProperty3Name: "",
    }));
  };
  const fProperty3_MultiSelect = (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sProperty3Arr: value,
      sProperty3Prnt: value?.length <= 0 ? "" : currentPrnt,
      sProperty3Name: value?.length <= 0 ? "" : currentName,
    }));
  };

  const fProperty4 = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sProperty4: e.target.value,
      sProperty4Arr: [],
      sProperty4Prnt: "",
      sProperty4Name: "",
    }));
  };
  const fProperty4_MultiSelect = (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sProperty4Arr: value,
      sProperty4Prnt: value?.length <= 0 ? "" : currentPrnt,
      sProperty4Name: value?.length <= 0 ? "" : currentName,
    }));
  };

  const fAnalysis1 = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sAnalysis1: e.target.value,
      sAnalysis1Arr: [],
      sAnalysis1Prnt: "",
      sAnalysis1Name: "",
    }));
  };
  const fAnalysis1_MultiSelect = (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sAnalysis1Arr: value,
      sAnalysis1Prnt: value?.length <= 0 ? "" : currentPrnt,
      sAnalysis1Name: value?.length <= 0 ? "" : currentName,
    }));
  };

  const fAnalysis2 = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sAnalysis2: e.target.value,
      sAnalysis2Arr: [],
      sAnalysis2Prnt: "",
      sAnalysis2Name: "",
    }));
  };
  const fAnalysis2_MultiSelect = (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sAnalysis2Arr: value,
      sAnalysis2Prnt: value?.length <= 0 ? "" : currentPrnt,
      sAnalysis2Name: value?.length <= 0 ? "" : currentName,
    }));
  };

  const fAnalysis3 = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sAnalysis3: e.target.value,
      sAnalysis3Arr: [],
      sAnalysis3Prnt: "",
      sAnalysis3Name: "",
    }));
  };
  const fAnalysis3_MultiSelect = (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sAnalysis3Arr: value,
      sAnalysis3Prnt: value?.length <= 0 ? "" : currentPrnt,
      sAnalysis3Name: value?.length <= 0 ? "" : currentName,
    }));
  };

  const fAnalysis4 = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sAnalysis4: e.target.value,
      sAnalysis4Arr: [],
      sAnalysis4Prnt: "",
      sAnalysis4Name: "",
    }));
  };
  const fAnalysis4_MultiSelect = (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sAnalysis4Arr: value,
      sAnalysis4Prnt: value?.length <= 0 ? "" : currentPrnt,
      sAnalysis4Name: value?.length <= 0 ? "" : currentName,
    }));
  };

  const fAnalysis5 = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sAnalysis5: e.target.value,
      sAnalysis5Arr: [],
      sAnalysis5Prnt: "",
      sAnalysis5Name: "",
    }));
  };
  const fAnalysis5_MultiSelect = (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sAnalysis5Arr: value,
      sAnalysis5Prnt: value?.length <= 0 ? "" : currentPrnt,
      sAnalysis5Name: value?.length <= 0 ? "" : currentName,
    }));
  };

  const fAnalysis6 = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sAnalysis6: e.target.value,
      sAnalysis6Arr: [],
      sAnalysis6Prnt: "",
      sAnalysis6Name: "",
    }));
  };
  const fAnalysis6_MultiSelect = (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name1).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sAnalysis6Arr: value,
      sAnalysis6Prnt: value?.length <= 0 ? "" : currentPrnt,
      sAnalysis6Name: value?.length <= 0 ? "" : currentName,
    }));
  };

  const fAnalysis7 = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sAnalysis7: e.target.value,
      sAnalysis7Arr: [],
      sAnalysis7Prnt: "",
      sAnalysis7Name: "",
    }));
  };

  const fAnalysis7_MultiSelect = (value) => {
    let currentPrnt = value.map((option) => option.Cd).join(",");
    let currentName = value.map((option) => option.Name).join(",");
    setHeadObject((obj) => ({
      ...obj,
      sAnalysis7Arr: value,
      sAnalysis7Prnt: value?.length <= 0 ? "" : currentPrnt,
      sAnalysis7Name: value?.length <= 0 ? "" : currentName,
    }));
  };

  const fTransType = (e) => {
    let vTransType = sWebTransTypeReportArr.find((obj) => {
      return obj.Uid === e.target.value;
    });

    setHeadObject((obj) => ({
      ...obj,
      sTransType: vTransType.Uid,
      sTransTypeName: vTransType.Value,
    }));
  };

  const fCancel = (e) => {
    setHeadObject(HeadObjectInit);
    setBufferObj(sBufferObjInit);
    setDetailSelectReportData(SummaryReporteData);
    setMainGroupData([]);
    setSubGroupData([]);
    setGroupData([]);
    setBrandData([]);
    setBrandGroupData([]);
    // setVendorData([]);
    // setCustomerData([]);
    setWMSSalesReportCheckbox(sWMSSalesReportCheckboxInit);
  };

  //Item start
  const GridDataColumnsItemSearch = [
    { field: "id", headerName: "ID", width: 70, hide: true },
    { field: "ItmCd", headerName: "ItmCd", width: 90 },
    { field: "Name1", headerName: "Name1", width: 450 },
    { field: "NameFL", headerName: "NameFL", width: 90 },
    { field: "MainGrpName", headerName: "MainGrpName", width: 90 },
    { field: "SuppRefNo1", headerName: "SuppRefNo1", width: 90 },
    { field: "Model", headerName: "Model", width: 90 },
    { field: "BaseUnitName", headerName: "BaseUnitName", width: 90 },
    { field: "BarCode", headerName: "BarCode", width: 90 },
  ];

  const ItemSearchData = ["Any", "Code", "Barcode", "Name", "RefNo", "NameFL"];
  const [sGridSelectRowData, setGridSelectRowData] = useState([]);
  const [sItemToggleDropdown, setItemToggleDropdown] = useState(false);
  const fItem = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sItem: e.target.value,
      sItemName: "",
      sItemCode: "",
    }));
  };
  const fItemName = (e) => {
    setHeadObject((obj) => ({
      ...obj,
      sItemName: e.target.value,
    }));
  };

  const fItemSearchKey = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      let vItemSearchFull = await GetItemFullSearchArr(HeadObject.sItemName);

      if (vItemSearchFull.length > 0) {
        setHeadObject((obj) => ({
          ...obj,
          sItemCode: vItemSearchFull[0].ItmCd,
          sItemName: vItemSearchFull[0].Name2,
        }));
      } else {
        fItemToggleClick(e);
      }
    } else if (e.key === "Backspace") {
      setHeadObject((obj) => ({
        ...obj,
        sItemCode: "",
        sItemName: e.target.value,
      }));
    }
  };

  //GCItemSearch
  const fGCToggleItemOnRowClick = async (e) => {
    let vItemSearchFull = await GetItemFullSearchArr(e.row.ItmCd);
    if (vItemSearchFull.length > 0) {
      setHeadObject((obj) => ({
        ...obj,
        sItemCode: vItemSearchFull[0].ItmCd,
        sItemName: vItemSearchFull[0].Name2,
      }));
      // document.getElementsByName("B_Qty")[0]?.focus();
    } else {
      // document.getElementsByName("B_ItmName")[0]?.focus();
    }
    setItemToggleDropdown(false);
  };

  //GCItemSearch
  const fGCToggleItemOnCellKeyDown = async (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fGCToggleItemOnRowClick(newSelectionModel);
    }
  };

  const [sItemSearchDropdownObj, setItemSearchDropdownObj] = useState({
    Type: "Any",
    Data: "",
  });

  const fOnChangeItem = (e) => {
    setItemSearchDropdownObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const fOnKeyUpItem = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      // SEARCHITEM001_GETROW
      GetSearchItem(
        sItemSearchDropdownObj.Data,
        sItemSearchDropdownObj.Type,
        setGridSelectRowData
      );
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  const handleClick = useCallback(() => {
    if (sItemToggleDropdown) {
      setItemToggleDropdown(false);
      setGridSelectRowData([]);
      setItemSearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    } else {
      setItemToggleDropdown(true);
      setTimeout(() => {
        document?.getElementsByName("Data")[0]?.focus();
      }, 100);
    }
  }, [sItemToggleDropdown]);

  const fItemToggleClick = (e) => {
    setGridSelectRowData([]);
    setItemSearchDropdownObj((obj) => ({
      ...obj,
      Data: HeadObject.sItemName,
    }));

    if (HeadObject.sItemName != "") {
      GetSearchItem(HeadObject.sItemName, "Any", setGridSelectRowData);
    }

    handleClick();
  };

  const vRdxDBKernObj = useSelector((state) => state.SliceDB.value.DBKernObj);

  const GetReportsView = async () => {
    // let xType = sBufferObj.sDetailReportRadioBtnName;
    let xSubType = sBufferObj.DetailSelectedReport;
    let xParam01 = "";
    let xPerc = "";
    let xProfitTyp = "";
    let xCDate1 = "";
    let xCDate2 = "";

    let urlPrint = vRdxDBKernObj.WEB_REPORT_BASE_URL?.Val;
    let sCurrentReport = "";
    let sReportTitle = "";
    if (
      sBufferObj.sDetailReportRadioBtnName?.toUpperCase() === "SUMMARY" &&
      sBufferObj.DetailSelectedReport?.toUpperCase() === "SMRY_LOC"
    ) {
      xParam01 = sBufferObj.sSummaryLocCustCheckBox;
    }
    if (
      sBufferObj.sDetailReportRadioBtnName?.toUpperCase() === "DETAIL" &&
      sBufferObj.DetailSelectedReport?.toUpperCase() === "DTIL_SAL_ABOV_COST"
    ) {
      xPerc = sBufferObj.sDetailSalesAbvCost;
    }
    if (
      sBufferObj.sDetailReportRadioBtnName?.toUpperCase() === "DETAIL" &&
      sBufferObj.DetailSelectedReport?.toUpperCase() === "DTIL_SAL_BELOW_COST"
    ) {
      xPerc = sBufferObj.sDetailSalesBelowCost;
    }
    if (
      sBufferObj.sDetailReportRadioBtnName?.toUpperCase() === "DETAIL" &&
      sBufferObj.DetailSelectedReport?.toUpperCase() === "DTIL_SAL_ABOV_BT_COST"
    ) {
      xProfitTyp = sBufferObj.sDetailSalesAboveBtCostFrom;
      xPerc = sBufferObj.sDetailSalesAboveBtCostTo;
    }
    if (sBufferObj.sDetailReportRadioBtnName?.toUpperCase() === "COMPARISON") {
      xCDate1 = moment(sBufferObj.sCompr_FromDt).format("MM-DD-YYYY");
      xCDate2 = moment(sBufferObj.sCompr_ToDt).format("MM-DD-YYYY");
    }

    const supplierName = HeadObject?.sVendorArr.map((x) => x.Name1).join(", ");
    const brandName = HeadObject?.sBrandArr.map((x) => x.Name1).join(", ");
    let ReportTitleObj = {
      DateBetween:
        "Between " +
        moment(HeadObject.sFromDate).format("DD-MM-YYYY") +
        " and " +
        moment(HeadObject.sToDate).format("DD-MM-YYYY"),
      Location: HeadObject.sLocationName,
      MainGrp: HeadObject.sMainGroupName,
      SubGrp: HeadObject.sSubGroupName,
      Group: HeadObject.sGroupName,
      ItemName: HeadObject.sItemName,
      Brand: brandName,
      // BrandSubGroup: HeadObject.sBrandGroupName,
      Supplier: supplierName,
      Country: HeadObject.sCountryName,
      Season: HeadObject.sSeasonName,
      SalesMan: HeadObject.sSalesManName,
      DocTyp: HeadObject.sDocTypeName,
      Customer: HeadObject.sCustomerName,
      TrnTyp: HeadObject.sTransTypeName,
      Analysis1: HeadObject.sAnalysis1Name,
      Analysis2: HeadObject.sAnalysis2Name,
      Analysis3: HeadObject.sAnalysis3Name,
      Analysis4: HeadObject.sAnalysis4Name,
      Analysis5: HeadObject.sAnalysis5Name,
      Analysis6: HeadObject.sAnalysis6Name,
      Analysis7: HeadObject.sAnalysis7Name,
      Property1: HeadObject.sProperty1Name,
      Property2: HeadObject.sProperty2Name,
      Property3: HeadObject.sProperty3Name,
      Property4: HeadObject.sProperty4Name,
    };

    // Remove the trailing "&" character
    sReportTitle = ReportTitle(ReportTitleObj);

    const suplGrpData = HeadObject?.sVendorArr.map((x) => x.AcCd).join(",");
    const brandGrpData = HeadObject?.sBrandArr.map((x) => x.UID).join(",");

    let ReportUrlObj = {
      ReportType: xSubType,
      date1: moment(HeadObject.sFromDate).format("MM-DD-YYYY"),
      date2: moment(HeadObject.sToDate).format("MM-DD-YYYY"),
      Loc: HeadObject.sLocationPrnt,
      MainGrp: HeadObject.sMainGroupPrnt,
      subGrp: HeadObject.sSubGroupPrnt,
      grp: HeadObject.sGroupPrnt,
      supplier: suplGrpData,
      brandCd: brandGrpData,
      itmCd: HeadObject.sItemCode,
      Paymode: "", //BY SIR
      RefBy1: HeadObject.sSalesManPrnt,
      Type: "",
      Country: HeadObject.sCountryPrnt,
      Season: HeadObject.sSeasonPrnt,
      TaxDept: "",
      DocType: HeadObject.sDocTypePrnt,
      TrnTyp: HeadObject.sTransType,
      Customer: HeadObject.sCustomerPrnt,
      Pivot: xParam01, //as of now by sir
      FocTyp: "",
      ProfitTyp: xProfitTyp,
      Perc: xPerc,
      v_CDate1: xCDate1,
      v_CDate2: xCDate2,
      UserCd: vRdxuserInfo.UserID,
      analysis1: HeadObject.sAnalysis1Prnt,
      analysis2: HeadObject.sAnalysis2Prnt,
      Analysis3: HeadObject.sAnalysis3Prnt,
      analysis4: HeadObject.sAnalysis4Prnt,
      analysis5: HeadObject.sAnalysis5Prnt,
      analysis6: HeadObject.sAnalysis6Prnt,
      analysis7: HeadObject.sAnalysis7Prnt,
      property1: HeadObject.sProperty1Prnt,
      property2: HeadObject.sProperty2Prnt,
      property3: HeadObject.sProperty3Prnt,
      property4: HeadObject.sProperty4Prnt,
      reportTitle: sReportTitle,
    };

    sCurrentReport = ReportUrl(ReportUrlObj);

    sCurrentReport = ReportRemoveSequenceChar(sCurrentReport);

    // console.log("ReportUrlObj", ReportUrlObj);
    // console.log("sCurrentReport", sCurrentReport);
    console.log(
      "sCurrentReport",
      urlPrint + "WMS/SalesReport?" + sCurrentReport
    );
    setWebReportUrlModal(urlPrint + "WMS/SalesReport?" + sCurrentReport);
    fWebReport();
  };

  const fPreview = async (e) => {
    let iValidationHead_Client = fValidationHead_Client(HeadObject);
    if (!iValidationHead_Client) return;
    let iValidationDetail_Client = fValidationDetail_Client(
      sBufferObj,
      HeadObject
    );
    if (!iValidationDetail_Client) return;
    await GetReportsView();
  };

  // CLICK ANY WHERE AND CLOSE IF TOGGLE IS CLOSED
  useEffect(() => {
    const handleClick = (event) => {
      if (sItemToggleDropdown) {
        const toggleElement = event.target.closest(".toggleSearch");
        if (!toggleElement) {
          setItemToggleDropdown(false);
          // setGC_Toggle_Head_BinName_ToggleDropDowm(false);
        }
      }
    };
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [sItemToggleDropdown]);

  //Modal Summary
  const [sSummaryModal, setSummaryModal] = useState(false);
  const fSummary = () => {
    setSummaryModal(true);
  };

  const fCloseSummaryModal = (e) => {
    setSummaryModal(false);
  };

  //Modal fWebReportModal
  const [sWebReportModal, setWebReportModal] = useState(false);
  const [sWebReportUrlModal, setWebReportUrlModal] = useState("");
  const fWebReport = () => {
    setWebReportModal(true);
  };

  const fCloseWebReportModal = (e) => {
    setWebReportModal(false);
  };

  const fLoad = async () => {
    await GetLocation(setLocationData);
    await GetWMSMISAttributes(
      setCountryData,
      setSeasonData,
      setSalesManData,
      setVendorData,
      setCustomerData,
      setDocTypeData
    );
    await GetItemsAnalysis(
      setProperty1Data,
      setProperty2Data,
      setProperty3Data,
      setProperty4Data,
      setAnalysis1Data,
      setAnalysis2Data,
      setAnalysis3Data,
      setAnalysis4Data,
      setAnalysis5Data,
      setAnalysis6Data,
      setAnalysis7Data
    );
  };

  useEffect(() => {
    fLoad();
  }, []);

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 0 }}
            columnSpacing={{ xs: 0, sm: 0, md: 0 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={vMediaQuery ? "py-4" : "py-4"}
          >
            <Grid item xs={12} sm={12} md={8}>
              <WmsHead
                fFromDate={fFromDate}
                fToDate={fToDate}
                fDate={fDate}
                fLocation_MultiSelect={fLocation_MultiSelect}
                sLocationData={sLocationData}
                fMainGroup_MultiSelect={fMainGroup_MultiSelect}
                sMainGroupData={sMainGroupData}
                fSubGroup_MultiSelect={fSubGroup_MultiSelect}
                sSubGroupData={sSubGroupData}
                fGroup_MultiSelect={fGroup_MultiSelect}
                sGroupData={sGroupData}
                fBrand_MultiSelect={fBrand_MultiSelect}
                sBrandData={sBrandData}
                fBrandGroup_MultiSelect={fBrandGroup_MultiSelect}
                sBrandGroupData={sBrandGroupData}
                fVendor_MultiSelect={fVendor_MultiSelect}
                sVendorData={sVendorData}
                fCustomer_MultiSelect={fCustomer_MultiSelect}
                sCustomerData={sCustomerData}
                fCountry_MultiSelect={fCountry_MultiSelect}
                fSeason_MultiSelect={fSeason_MultiSelect}
                fSalesMan_MultiSelect={fSalesMan_MultiSelect}
                fDocType_MultiSelect={fDocType_MultiSelect}
                fProperty1={fProperty1}
                fProperty1_MultiSelect={fProperty1_MultiSelect}
                fProperty2={fProperty2}
                fProperty2_MultiSelect={fProperty2_MultiSelect}
                fProperty3={fProperty3}
                fProperty3_MultiSelect={fProperty3_MultiSelect}
                fProperty4={fProperty4}
                fProperty4_MultiSelect={fProperty4_MultiSelect}
                fAnalysis1={fAnalysis1}
                fAnalysis1_MultiSelect={fAnalysis1_MultiSelect}
                fAnalysis2={fAnalysis2}
                fAnalysis2_MultiSelect={fAnalysis2_MultiSelect}
                fAnalysis3={fAnalysis3}
                fAnalysis3_MultiSelect={fAnalysis3_MultiSelect}
                fAnalysis4={fAnalysis4}
                fAnalysis4_MultiSelect={fAnalysis4_MultiSelect}
                fAnalysis5={fAnalysis5}
                fAnalysis5_MultiSelect={fAnalysis5_MultiSelect}
                fAnalysis6={fAnalysis6}
                fAnalysis6_MultiSelect={fAnalysis6_MultiSelect}
                fAnalysis7={fAnalysis7}
                fAnalysis7_MultiSelect={fAnalysis7_MultiSelect}
                fTransType={fTransType}
                //multiselect
                sProperty1Data={sProperty1Data}
                sProperty2Data={sProperty2Data}
                sProperty3Data={sProperty3Data}
                sProperty4Data={sProperty4Data}
                sAnalysis1Data={sAnalysis1Data}
                sAnalysis2Data={sAnalysis2Data}
                sAnalysis3Data={sAnalysis3Data}
                sAnalysis4Data={sAnalysis4Data}
                sAnalysis5Data={sAnalysis5Data}
                sAnalysis6Data={sAnalysis6Data}
                sAnalysis7Data={sAnalysis7Data}
                sWebWMSSalesReportData={sWebWMSSalesReportData}
                sWebBetweenReportArr={sWebBetweenReportArr}
                sWebTransTypeReportArr={sWebTransTypeReportArr}
                sCountryData={sCountryData}
                sSeasonData={sSeasonData}
                sSalesManData={sSalesManData}
                sDocTypeData={sDocTypeData}
                HeadObject={HeadObject}
                setHeadObject={setHeadObject}
                fLocation={fLocation}
                fMainGroup={fMainGroup}
                fSubGroup={fSubGroup}
                fGroup={fGroup}
                fVendor={fVendor}
                fCustomer={fCustomer}
                fBrand={fBrand}
                // fBrandGroup={fBrandGroup}
                fItem={fItem}
                fCountry={fCountry}
                fSeason={fSeason}
                fSalesMan={fSalesMan}
                fDocType={fDocType}
                fItemName_onKeyUp={fItemSearchKey}
                fItemName={fItemName} //onchange main input
                xMediaQuery={vMediaQuery} //mobile screen
                xonClickbtn={fItemSearchKey} // onclick icon open div on main screen
                xrows={sGridSelectRowData} //Grid Row GCToggle Search from API
                xcolumns={GridDataColumnsItemSearch} //GCToggleSearch-Grid col GCToggle Search fron Action
                xRowCellClick={fGCToggleItemOnCellKeyDown} //GCToggleSearch-grid clic
                xRowClick={fGCToggleItemOnRowClick} //GCToggleSearch- grid click
                xToggle={sItemToggleDropdown} //GCToggleSearch-to show div using true/false (after xonClickbtn state value will be passed)
                xData={ItemSearchData} // GCToggleSearch-select-tag arr
                xOnChangeDropdownInput={fOnChangeItem} //GCToggleSearch-input search onchane DATA/TYPE
                xDropdownObj={sItemSearchDropdownObj} // GCToggleSearch-object DATA/TYPE
                xOnKeyUpDropdownInput={fOnKeyUpItem} //GCToggleSearch
                //Checkbox start
                sWMSSalesReportCheckBoxModal={sWMSSalesReportCheckBoxModal}
                fOpenWMSSalesReportCheckBoxModal={
                  fOpenWMSSalesReportCheckBoxModal
                }
                fCloseWMSSalesReportCheckBoxModal={
                  fCloseWMSSalesReportCheckBoxModal
                }
                sIsChecked={sIsChecked}
                WMSSalesReportCheckbox={WMSSalesReportCheckbox}
                fSetCheckBox={fSetCheckBox}
                fIsAllChecked={fIsAllChecked}
                //Checkbox end
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={3}
              className={vMediaQuery ? "hide-content" : " "}
            >
              <WmsContent
                xtitle={"Detail Report"}
                selectedOption={sBufferObj.sDetailReportRadioBtnName}
                DetailReportRadioBtn={DetailReportRadioBtn}
                sBufferObj={sBufferObj}
                sDetailSelectReportData={sDetailSelectReportData}
                fDetailSelectedReport={fDetailSelectedReport}
                fCompr_ToDt={fCompr_ToDt}
                fCompr_FromDt={fCompr_FromDt}
                fComprSales_ToDt={fComprSales_ToDt}
                fComprSales_FromDt={fComprSales_FromDt}
                fDetailSalesAbvCost={fDetailSalesAbvCost}
                fDetailSalesBelowCost={fDetailSalesBelowCost}
                fDetailSalesAboveBtCostFrom={fDetailSalesAboveBtCostFrom}
                fDetailSalesAboveBtCostTo={fDetailSalesAboveBtCostTo}
                fSummaryLocCustCheckBox={fSummaryLocCustCheckBox}
              />
            </Grid>
          </Grid>
          <Grid
            container
            rowSpacing={{ xs: 1, sm: 0, md: 0 }}
            columnSpacing={{ xs: 1, sm: 0, md: 3 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={
              vMediaQuery
                ? " justify-content-center text-center"
                : "py-2 justify-content-center text-center"
            }
          >
            <Grid item xs={6} sm={6} md={"auto"} className="text-center">
              <CmpButton
                xbtnName="Preview"
                xOnClick={fPreview}
                xVariant="contained"
                xDisabled={false}
                xSize="small"
                xId={""}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={"auto"} className="text-center">
              <CmpButton
                xbtnName="Cancel"
                xOnClick={fCancel}
                xVariant="contained"
                xDisabled={false}
                xSize="small"
                xId={""}
              />
            </Grid>

            <Grid
              item
              xs={6}
              sm={6}
              md={"auto"}
              className={
                vMediaQuery ? "text-center" : "text-center hide-content"
              }
            >
              <CmpButton
                xbtnName="Detail"
                xOnClick={fSummary}
                xVariant="contained"
                xDisabled={false}
                xSize="small"
                xId={""}
              />
            </Grid>
          </Grid>
        </div>
      </div>

      {/* summary  */}
      <Modal
        open={sSummaryModal}
        onClose={fCloseSummaryModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance">
          <GCTitleSticky title={"Detail Report"} onClose={fCloseSummaryModal} />

          <div className="py-3 px-2">
            <WmsContent
              xtitle={"Detail Report"}
              selectedOption={sBufferObj.sDetailReportRadioBtnName}
              DetailReportRadioBtn={DetailReportRadioBtn}
              sBufferObj={sBufferObj}
              sDetailSelectReportData={sDetailSelectReportData}
              fDetailSelectedReport={fDetailSelectedReport}
              fCompr_ToDt={fCompr_ToDt}
              fCompr_FromDt={fCompr_FromDt}
              fComprSales_ToDt={fComprSales_ToDt}
              fComprSales_FromDt={fComprSales_FromDt}
              fDetailSalesAbvCost={fDetailSalesAbvCost}
              fDetailSalesBelowCost={fDetailSalesBelowCost}
              fDetailSalesAboveBtCostFrom={fDetailSalesAboveBtCostFrom}
              fDetailSalesAboveBtCostTo={fDetailSalesAboveBtCostTo}
              fSummaryLocCustCheckBox={fSummaryLocCustCheckBox}
            />
          </div>
        </Box>
      </Modal>

      {/* webReport  */}

      <GCWebReport
        xfCloseWebReportModal={fCloseWebReportModal}
        xWebReportUrlModal={sWebReportUrlModal}
        xTitle="Report"
        xWebReportModal={sWebReportModal}
      />
    </div>
  );
}
